import { PortalOperator } from './portal-operator';

export class Supervisor extends PortalOperator {
    Company?: string;
    PublicInstitution?: string;
    FinesCount?: number;
    VehicleChecksCount?: number;
    TotalFines?: number;

    // Web properties
    NewPassword?: string;
}
